var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      !_vm.showResumeModal
        ? _c("ModalFullScreen", {
            attrs: { withBgClickEvent: true },
            on: {
              close: function ($event) {
                return _vm.$emit("close")
              },
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "header",
                  fn: function () {
                    return [
                      _c(
                        "div",
                        {
                          staticClass:
                            "flex justify-between bg-white pr-4 sm:pr-6 sm:p-2 pl-0",
                        },
                        [
                          _c(
                            "h3",
                            {
                              staticClass:
                                "text-lg leading-6 font-medium text-gray-900",
                            },
                            [_vm._v(" Upload Resume ")]
                          ),
                        ]
                      ),
                      _c(
                        "span",
                        {
                          staticClass:
                            "cursor-pointer flex items-center justify-center absolute top-6 right-6",
                          on: {
                            click: function ($event) {
                              return _vm.$emit("close")
                            },
                            mouseover: function ($event) {
                              _vm.isHovered = true
                            },
                            mouseout: function ($event) {
                              _vm.isHovered = false
                            },
                          },
                        },
                        [
                          !_vm.isHovered
                            ? _c("CrossIcon", { staticClass: "h-3.5 w-3.5" })
                            : _vm._e(),
                          _vm.isHovered
                            ? _c("CrossIconHover", {
                                staticClass: "close-icon",
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "content",
                  fn: function () {
                    return [
                      _c("div", {}, [
                        _vm.processing
                          ? _c(
                              "span",
                              {
                                staticClass:
                                  "flex flex-col items-center fileContainer justify-center customResumeBg",
                              },
                              [_c("Spinner")],
                              1
                            )
                          : _vm._e(),
                        !_vm.hasFile && !_vm.processing
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "customResumeBg border-gray-200 flex flex-col items-center justify-center",
                              },
                              [
                                !_vm.hasFile && !_vm.processing
                                  ? _c("input", {
                                      ref: "fileUpload",
                                      staticClass: "uploadText hidden",
                                      attrs: { type: "file" },
                                      on: { input: _vm.changeFiles },
                                    })
                                  : _vm._e(),
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "uploadButton flex flex-col justify-center items-center w-full h-full",
                                    on: { click: _vm.handleFileUpload },
                                  },
                                  [
                                    !_vm.fileErrorName && !_vm.fileError
                                      ? _c(
                                          "svg",
                                          {
                                            attrs: {
                                              xmlns:
                                                "http://www.w3.org/2000/svg",
                                              width: "32",
                                              height: "33",
                                              viewBox: "0 0 32 33",
                                              fill: "none",
                                            },
                                          },
                                          [
                                            _c("path", {
                                              attrs: {
                                                d: "M15.0625 5.25H16.9375C17.1042 5.25 17.1875 5.33333 17.1875 5.5V27.5C17.1875 27.6667 17.1042 27.75 16.9375 27.75H15.0625C14.8958 27.75 14.8125 27.6667 14.8125 27.5V5.5C14.8125 5.33333 14.8958 5.25 15.0625 5.25Z",
                                                fill: "black",
                                                "fill-opacity": "0.45",
                                              },
                                            }),
                                            _c("path", {
                                              attrs: {
                                                d: "M5.5 15.3125H26.5C26.6667 15.3125 26.75 15.3958 26.75 15.5625V17.4375C26.75 17.6042 26.6667 17.6875 26.5 17.6875H5.5C5.33333 17.6875 5.25 17.6042 5.25 17.4375V15.5625C5.25 15.3958 5.33333 15.3125 5.5 15.3125Z",
                                                fill: "black",
                                                "fill-opacity": "0.45",
                                              },
                                            }),
                                          ]
                                        )
                                      : _c(
                                          "svg",
                                          {
                                            attrs: {
                                              xmlns:
                                                "http://www.w3.org/2000/svg",
                                              width: "33",
                                              height: "32",
                                              viewBox: "0 0 33 32",
                                              fill: "none",
                                            },
                                          },
                                          [
                                            _c("path", {
                                              attrs: {
                                                d: "M15.5625 4.75H17.4375C17.6042 4.75 17.6875 4.83333 17.6875 5V27C17.6875 27.1667 17.6042 27.25 17.4375 27.25H15.5625C15.3958 27.25 15.3125 27.1667 15.3125 27V5C15.3125 4.83333 15.3958 4.75 15.5625 4.75Z",
                                                fill: "#F10519",
                                              },
                                            }),
                                            _c("path", {
                                              attrs: {
                                                d: "M6 14.8125H27C27.1667 14.8125 27.25 14.8958 27.25 15.0625V16.9375C27.25 17.1042 27.1667 17.1875 27 17.1875H6C5.83333 17.1875 5.75 17.1042 5.75 16.9375V15.0625C5.75 14.8958 5.83333 14.8125 6 14.8125Z",
                                                fill: "#F10519",
                                              },
                                            }),
                                          ]
                                        ),
                                    !_vm.fileErrorName && !_vm.fileError
                                      ? _c("p", { staticClass: "uploadText" }, [
                                          _vm._v(" Upload File "),
                                        ])
                                      : _c("p", { staticClass: "errorClass" }, [
                                          _vm._v(_vm._s(_vm.fileErrorName)),
                                        ]),
                                  ]
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm.hasFile
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "fileContainer flex flex-row items-center justify-center",
                              },
                              [
                                _vm.fileName.split(".")[1] === "pdf"
                                  ? _c(
                                      "span",
                                      [
                                        _c("PDFIcon", {
                                          staticClass: "w-8 h-8",
                                        }),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm.fileName.split(".")[1] === "docx" ||
                                _vm.fileName.split(".")[1] === "doc"
                                  ? _c(
                                      "span",
                                      [
                                        _c("DOCIcon", {
                                          staticClass: "w-8 h-8",
                                        }),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _c(
                                  "div",
                                  { staticClass: "flex flex-col mx-2" },
                                  [
                                    _c(
                                      "p",
                                      {
                                        staticClass:
                                          "text-sm text-primary-black font-normal",
                                      },
                                      [_vm._v(" " + _vm._s(_vm.fileName) + " ")]
                                    ),
                                    _c(
                                      "p",
                                      {
                                        staticClass:
                                          "text-xs font-normal text-gray-new",
                                      },
                                      [_vm._v(_vm._s(_vm.fileSize))]
                                    ),
                                  ]
                                ),
                                _c(
                                  "button",
                                  {
                                    staticClass: "-mt-4",
                                    on: {
                                      click: function ($event) {
                                        _vm.hasFile = false
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "svg",
                                      {
                                        attrs: {
                                          xmlns: "http://www.w3.org/2000/svg",
                                          width: "18",
                                          height: "18",
                                          viewBox: "0 0 18 18",
                                          fill: "none",
                                        },
                                      },
                                      [
                                        _c("path", {
                                          attrs: {
                                            d: "M12.7632 6.86623C13.0756 6.55388 13.0756 6.04662 12.7632 5.73427C12.4509 5.42191 11.9436 5.42191 11.6313 5.73427L9 8.36803L6.36623 5.73676C6.05388 5.42441 5.54662 5.42441 5.23427 5.73676C4.92191 6.04912 4.92191 6.55638 5.23427 6.86873L7.86803 9.5L5.23676 12.1338C4.92441 12.4461 4.92441 12.9534 5.23676 13.2657C5.54912 13.5781 6.05638 13.5781 6.36873 13.2657L9 10.632L11.6338 13.2632C11.9461 13.5756 12.4534 13.5756 12.7657 13.2632C13.0781 12.9509 13.0781 12.4436 12.7657 12.1313L10.132 9.5L12.7632 6.86623Z",
                                            fill: "#A8AEB8",
                                          },
                                        }),
                                      ]
                                    ),
                                  ]
                                ),
                              ]
                            )
                          : _vm._e(),
                        _c("div", { staticClass: "flex pt-3" }, [
                          _c(
                            "div",
                            { staticClass: "flex w-full justify-end mb-3" },
                            [
                              _c("UIButton", {
                                staticClass: "mr-3",
                                attrs: {
                                  buttonText: "Cancel",
                                  variant: "outline",
                                  size: "lg",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.$emit("close")
                                  },
                                },
                              }),
                              _c("UIButton", {
                                attrs: {
                                  disabled: _vm.processing || !_vm.hasFile,
                                  buttonText: "Upload",
                                  variant: "black",
                                  size: "lg",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.addFileUpload()
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                        ]),
                      ]),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              2571348826
            ),
          })
        : _vm._e(),
      _vm.showResumeModal
        ? _c("CompanyContractorDetailedInformation", {
            attrs: {
              name: "modal-lv2",
              resumeData: _vm.resumeData,
              currentUserId: _vm.userId,
              contractorId: _vm.contractorId,
              contractorUserId: _vm.contractorUserId,
            },
            on: {
              close: function ($event) {
                _vm.showResumeModal = false
              },
              refetchProfileByManagement: function ($event) {
                return _vm.$emit("refetchResource")
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }